import dateService from '@gem/services/date-service';

interface ITimeValidateParams {
  value: string;
  data: {
    minTime?: string | null;
    maxTime?: string | null;
    errorText?: string;
  };
}

export const timeValidation = ({ value, data }: ITimeValidateParams): string | null => {
  const time = dateService.parseTime(value);
  if (!time) {
    return ' ';
  }

  const minTime = dateService.parseTime(data.minTime || '');
  const maxTime = dateService.parseTime(data.maxTime || '');
  if (!minTime && !maxTime) {
    return null;
  }

  const isIncorrect = time.some((v: number, i: number) => {
    if (
      minTime &&
      time[i] < minTime[i] &&
      !Array(i)
        .fill(0)
        .some((_v: number, j: number) => minTime[j] !== time[j])
    ) {
      return true;
    }

    if (
      maxTime &&
      time[i] > maxTime[i] &&
      !Array(i)
        .fill(0)
        .some((_v: number, j: number) => maxTime[j] !== time[j])
    ) {
      return true;
    }

    return false;
  });

  return isIncorrect ? data.errorText || ' ' : null;
};
